import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import block from 'bem-cn';

import CheckBox from 'components/CheckBox';
import Button from 'components/Button';

import itemsList from './data';

import './Training.scss';

const b = block('training')

const Training = () => {
  const locale = useSelector(state => state.locale.locale);

  const [isOpen, setIsOpen] = useState(!JSON.parse(localStorage.getItem('glassBridgeIsNotShow')));  
  const [isChoosenDontShow, setIsChoosenDontShow] = useState(false);
  const [indexTempSlide, setIndexTempSlide] = useState(0);

  const close = useCallback(() => {
    if (isChoosenDontShow) {
      localStorage.setItem('glassBridgeIsNotShow', true)
    }
    setIsOpen(false)
  }, [isChoosenDontShow])

  const changeSlide = useCallback(value => {
    if ((value < 0) && indexTempSlide > 0) {
      setIndexTempSlide(indexTempSlide + value);
    }
    if ((value > 0) && indexTempSlide < itemsList.length - 1) {
      setIndexTempSlide(indexTempSlide + value);
    }
    if ((value > 0) && indexTempSlide === itemsList.length - 1) {
      close();
    }
  }, [close, indexTempSlide])

  useEffect(() => {
    if (localStorage.getItem('glassBridgeIsNotShow') === null) {
      localStorage.setItem('glassBridgeIsNotShow', false)
    }
  }, [])

  const items = itemsList.map(t => <div className={b('item')} key={t.titleId}>
    <img className={b('image')} src={t.icon} alt="" />
    <div className={b('title')}>{locale[t.titleId]}</div>
    <div className={b('text')}>{locale[t.textId]}</div>
  </div>)

  return isOpen ? <article className={b()}>
    <div className={b('header')}>
      <div className={b('check-box')}>
        <CheckBox value={isChoosenDontShow} changeValue={setIsChoosenDontShow} />
      </div>
      {locale.dontShowAgain}
      <div className={b('skip')} onClick={close}>
        {locale.skip}
      </div>
    </div>
    <div className={b('content')}>
      <div className={b('items')} style={{ marginLeft: `calc(-${indexTempSlide * 100}% - ${indexTempSlide}rem`}}>
        {items}
      </div>
      <div className={b('buttons-container')}>
        <div className={b('button-container')}>
          <Button
            text={locale.back}
            size='container'
            isUppercase
            color='dark'
            callBack={() => changeSlide(-1)}
            fontSize='large'/>
        </div>
        <div className={b('button-container')}>
          <Button
            text={indexTempSlide !== itemsList.length - 1 ? locale.next : locale.close}
            size='container'
            isUppercase
            color='orange'
            callBack={() => changeSlide(1)}
            fontSize='large'/>
        </div>
      </div>
      <div className={b('indicator-block')}>
        <div className={b('indicator')} style={{ marginLeft: `${100 * indexTempSlide / itemsList.length}%`}} />
      </div>
    </div>
  </article> : null;
}

export default Training;